<template>
  
  <section>
    
	<div class="header header-fixed header-auto-show header-logo-app">
        <a href="/dashboard" class="header-title"><img :src="logoSrc" height="45px"></a>
		<a href="/dashboard" data-back-button class="header-icon header-icon-1"><i class="fas fa-arrow-left"></i></a>
	</div>
 
  </section>

</template>

<script>

//import { mapState } from 'vuex'
import * as db from "./../database.js";

export default {
    computed: {
      // Logo de la empresa (config.json); si no hay, usa el de NetCar como respaldo
      logoSrc() {
        var url = db.getLogoUrl();
        return url ? url : require("./../assets/images/logonetcar.png");
      }
    },
    methods: {
      logout: function () {
        this.$store.dispatch('logout')
        .then(() => {
          this.$router.push('/login')
        })
      }
    }
}
</script>
